export default [
    "Wedding",
    "Corporate Event",
    "Private Event",
    "Other"
];
